import {gql} from '@apollo/client'

// Admin: set rebilling markups (global, or per-agent with targetUserId).
export const SET_BILLING_MARKUPS = gql`
  mutation SetBillingMarkups($voiceMarkupPct: Float, $rentalMarkup: Float, $targetUserId: ID) {
    setBillingMarkups(voiceMarkupPct: $voiceMarkupPct, rentalMarkup: $rentalMarkup, targetUserId: $targetUserId) {
      success
      markups
    }
  }
`

// Admin: release any owned Twilio number (pool + PolicyDial cleanup, then delete
// on Twilio). Never automatic — the admin confirms each release.
export const RELEASE_TWILIO_NUMBER = gql`
  mutation ReleaseTwilioNumber($phoneNumber: String!) {
    releaseTwilioNumber(phoneNumber: $phoneNumber) {
      success
      warnings
    }
  }
`

// Admin: buy N voice numbers (same area code / state) and add them to the
// local-presence CID pool. Grows the pool without needing a burned number.
export const ADD_NUMBERS_TO_POOL = gql`
  mutation AddNumbersToPool($state: String!, $areaCode: String, $quantity: Int) {
    addNumbersToPool(state: $state, areaCode: $areaCode, quantity: $quantity) {
      success
      message
      warnings
      result
    }
  }
`
